import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const tableEditingKey = new PluginKey('selectingCells');
export const fixTablesKey = new PluginKey('fix-tables');
